const OBJECT_ID_PATTERN = /^[a-f0-9]{24}$/i;

export const isValidObjectId = (value?: string): boolean => {
    return !!value && OBJECT_ID_PATTERN.test(value);
};

export const buildLegacyStationConnectorPath = (
    stationId: string,
    connectorId: string,
    search = '',
    hash = ''
): string => `/stations/${stationId}/${connectorId}${search}${hash}`;
